// Zdarzenia konwersji (spec sekcja 24).
//
// Wysylamy rownolegle dwoma kanalami, bo w serwisie dzialaja oba:
//   - gtag()      -> Google Ads / GA4 wpiete bezposrednio,
//   - dataLayer   -> Google Tag Manager (GTM-PXRLNPVR), ktory przekazuje dalej.
// Jesli ktoregos nie ma, po prostu go pomijamy - zdarzenie nigdy nie wysypie strony.
//
// Kluczowe zdarzenia do oznaczenia w GA4: booking_complete, form_submit, phone_click.

const send = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  const payload = { page_location: window.location.href, ...params };
  try {
    window.gtag?.('event', name, payload);
  } catch {
    /* brak gtag - nie przerywamy interakcji uzytkownika */
  }
  try {
    window.dataLayer?.push({ event: name, ...payload });
  } catch {
    /* brak dataLayer */
  }
};

export const track = send;

/** Handler do CTA: <a onClick={onCta('booking_click', 'hero')}> */
export const onCta = (name, location) => () => send(name, { cta_location: location });

/**
 * Jedno globalne nasluchiwanie zamiast handlera przy kazdym linku.
 * Dziala takze dla linkow wyrenderowanych przez prerender, zanim React je przejmie.
 */
export function initAutoTracking() {
  if (typeof document === 'undefined' || window.__sensoriniTracking) return;
  window.__sensoriniTracking = true;

  document.addEventListener(
    'click',
    (e) => {
      const link = e.target instanceof Element ? e.target.closest('a[href]') : null;
      if (!link) return;
      const href = link.getAttribute('href') || '';

      if (href.startsWith('tel:')) return send('phone_click', { link_url: link.href });
      if (href.startsWith('mailto:')) return send('email_click', { link_url: link.href });
      if (href.includes('google.com/maps/dir') || href.includes('/maps/dir/')) {
        return send('directions_click', { link_url: link.href });
      }
      if (href.includes('google.com/maps')) return send('map_click', { link_url: link.href });
      if (href.endsWith('.pdf')) return send('pdf_download', { link_url: link.href });
      if (link.dataset.cta) {
        return send(link.dataset.cta === 'booking' ? 'booking_click' : link.dataset.cta, {
          cta_location: link.dataset.ctaLocation || '',
          link_url: link.href,
        });
      }
      return undefined;
    },
    { capture: true }
  );
}
